import { Box, Button, Grid } from "@mui/material";
import { useAuth } from "react-oidc-context";
import AuthViewHeader from "./utils/AuthHeader";
import { appTheme } from "./utils/theme";

function Login() {
  const auth = useAuth();
  const COPYRIGHT_TEXT = '© 2024 StreamFin. All rights reserved.';

  if (auth.isLoading) {
    return <div>Loading...</div>;
  }

  if (auth.error) {
    return <div color="blue">Encountering error... {auth.error.message}</div>;
  }

  return (
    <Grid
      container
      sx={{
        minHeight: '100vh',
        backgroundColor: appTheme.palette.background.default,
        px: { xs: 3, md: 8 },
        py: { xs: 4, md: 6 },
      }}
    >
      <Grid
        item
        xs={12}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            maxWidth: 480,
            width: '100%',
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <AuthViewHeader />

          <Button
            fullWidth
            size="large"
            variant="contained"
            sx={{
              mt: 8,
              borderRadius: 1,
              fontWeight: 500,
            }}
            onClick={() => auth.signinRedirect()}
          >
            LOGIN COM SSO
          </Button>

          <Box
            sx={{
              mt: 'auto',
              pt: 4,
              textAlign: { xs: 'center', md: 'left' },
              color: appTheme.palette.text.secondary,
              fontSize: 14,
            }}
          >
            {COPYRIGHT_TEXT}
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
}  

export { Login };
